import React, { useEffect, useState, useRef } from 'react';
import { ArrowLeft, Ban, CalendarClock, CheckCheck, CircleX, Construction, Crown, Link, MapPin, Repeat1, SendHorizonal, SendHorizonalIcon, Trash2, User } from 'lucide-react';
import icEmpire from "../assets/logos/logo-empire-str.png";
import { useSocket } from '../Context/SocketContext';
import moment from 'moment';
import { infoUser } from '../utils/auth';
import Loader from './Loader';
import { post } from '../utils/fetcher';
import TalkTypeValidPaiement from './TalkTypeValidPaiement';
import TalkTypeRefusePaiement from './TalkTypeRefusePaiement';
import TalkTypeWaitAskPaiement from './TalkTypeWaitAskPaiement';
import TalkTypeWaitAskPaiementAccept from './TalkTypeWaitAskPaiementAccept';
import TalkTypeWaitAskPaiementReceived from './TalkTypeWaitAskPaiementReceived';
import TalkTypeWaitAskPaiementRefuseReceived from './TalkTypeWaitAskPaiementRefuseReceived';
import TalkTypeWaitAskPaiementRefuse from './TalkTypeWaitAskPaiementRefuse';
import TalkTypeValidByUser from './TalkTypeValidByUser';
import ModalPremiumDate from './ModalPremiumDate';

const CenterTalk = ({ el, iMessages, init, type = "stream", onBack }) => {

    const e = iMessages.find(em => em.user.id == el.user.id)


    const { projectJson, socket, socketSport } = useSocket()
    const refTalks = useRef(null)
    const [message, setMessage] = useState("")
    const [load, setLoad] = useState(false)
    const [notifTalk, setNotifTalk] = useState("")
    const [ipInfo, setIpInfo] = useState(null)
    const [moreInfo, setMoreInfo] = useState(null)
    const [openMore, setOpenMore] = useState(false)
    const [openPremium, setOpenPremium] = useState(false)
    const [premiumInfo, setPremiumInfo] = useState(null)
    const [countAskPaiement, setCountAskPaiement] = useState(null)
    const userToken = infoUser()
    const matchSocket = type == "stream" ? socket : socketSport
    const mapTypePay = {
        streaming: { label: "Streaming", cls: "bce cw" },
        sport: { label: "Sport", cls: "bcs cw" },
        vitrine: { label: "Vitrine", cls: "bcw cb" },
        premium: { label: "Premium", cls: "bcyellow cb" },
    }

    const sendMessage = async (x) => {
        x && x.preventDefault();
        if (!load) {
            setLoad(true)
            const response = await new Promise((resolve, reject) => {
                matchSocket.emit(
                    'empire_send_message_user',
                    {
                        token: userToken.expecttoken,
                        message,
                        email: e.user.email,
                        idUser: e.user.id,
                        nameAdmin: userToken?.name
                    },
                    (e) => {
                        if (e.isSend) resolve(e.status);
                        else reject("");
                    }
                );
            });


            if (!response) {
                setNotifTalk({ txt: "Une erreur est sruvenue", c: "bce cw" });
                setLoad(false)
                return;
            }
            setNotifTalk({ txt: `Message Envoyé - (${response})`, c: "bcs cb" })
            setMessage("")
            init()
            setLoad(false)
        }
    }
    const majStatus = () => {
        const getuserMessageSend = e?.messages?.filter(el => !el.date_read && el.role == "user");

        if (getuserMessageSend?.length > 0) {
            matchSocket.emit('empire_maj_message_read', { token: userToken.expecttoken, data: getuserMessageSend, idUser: e.user.id }, (e) => {
                if (e) {
                    init()
                }
            })
        }
    }
    const getIpInfo = async () => {
        try {

            matchSocket.emit('empire_info_ip_user_talk', { token: userToken.expecttoken, user_id: e.user.id }, async (res) => {


                if (res.length > 0) {
                    const ip = res[0];
                    const response = await post("/info/get_ip_detail", { ip: ip });
                    if (response) {
                        setIpInfo(response);
                    }
                }
            })
        } catch (err) {
            console.log(err);

        }
    }
    const getTimeAskPaiement = async () => {
        
        try {
            
            if (e?.user?.id && userToken) {
                matchSocket.emit('empire_count_ask_paiement', { token: userToken.expecttoken, user_id: e.user.id }, (res) => {
                    setCountAskPaiement(res)
                })
            }
        } catch (err) {
            console.log(err);

        }
    }
    const getInfoUser = () => {
        matchSocket.emit('empire_get_user_more_info', { token: userToken.expecttoken, idUser: e.user.id }, (e) => {

            setMoreInfo(e)
        })
    }
    const getPremium = () => {
        if (!e?.user?.id) return
        matchSocket.emit('empire_user_is_premium', { token: userToken.expecttoken, idUser: e.user.id }, (res) => {
            setPremiumInfo(res || null)
        })
    }
    const toggleMoreInfo = () => {
        if (!moreInfo) getInfoUser()
        setOpenMore(v => !v)
    }
    const deleteMessage = (id) => {
        if (id) {
            matchSocket.emit('empire_delete_line_message', { token: userToken.expecttoken, idMessage: id }, (e) => {
                console.log(e);

                init();
            })
        }
    }
    const deleteAllMessage = () => {
        const confirmDelete = window.confirm(
            "Êtes-vous sûr de vouloir supprimer les messages ? Cette action est irréversible."
        );
        if (!confirmDelete) return;
        matchSocket.emit('empire_delete_all_message', { token: userToken.expecttoken, idUser: el.user.id }, (e) => {
            console.log(e);
            init()
        })
    }
    const blockUser = () => {
        matchSocket.emit('empire_tracker_block_user', { token: userToken.expecttoken, user_id: e.user.id }, (res) => {
            // callback
        })
    }
    const remvoeCountAskPaiement = async () => {
        if (countAskPaiement !== null) {
            await matchSocket.emit('empire_delete_ask_paiement', { token: userToken.expecttoken, idCountAskPaiement: countAskPaiement.id }, (e) => {
                getTimeAskPaiement()
            })
        }
    }
    useEffect(() => {
        if (refTalks.current) {
            refTalks.current.scrollTop = refTalks.current.scrollHeight;
        }
        getTimeAskPaiement()
        setMoreInfo(null)
        setOpenMore(false)
        setIpInfo(null)
        setPremiumInfo(null)
        majStatus()
        getIpInfo()
        getPremium()

    }, [e])
    if (!e) {
        return <></>
    }
    const premiumDays = premiumInfo?.date_premium
        ? moment(premiumInfo.date_premium).endOf('day').diff(moment(), 'days')
        : null
    const premiumExpired = premiumDays !== null && premiumDays < 0
    return (
        <div className='container-center-talk'>
            <button onClick={() => onBack && onBack()} className='talk-back only-mobile'>
                <ArrowLeft size={20} color='#fff' />
                <span className='fr cw'>Retour</span>
            </button>
            <div className='pb1 '>
                <div className='info-ip'>
                    <div className='df gap1'>
                        {type == "stream" && (
                            <img className='avatar' src={projectJson?.href + "/images/users/" + e.user.path}></img>
                        )}
                        {type == "sport" && (
                            <User className='avatar' />
                        )}
                        <div className='df gap1 jcsb flex1'>
                            <div className='df fdc aifs'>
                                <p style={{ fontSize: "0.8em" }} className='fl cw'>{e.user.email}</p>
                                {e.user.slug && (
                                    <p style={{ fontSize: "0.8em" }} className='fl cw'>{e.user.slug}</p>
                                )}
                                <div className='df aic gap1 mt1 block-action-talk-user'>
                                    {premiumInfo?.date_premium && (
                                        <span className={`premium-badge df aic gap1 fr ${premiumExpired ? "expired" : ""}`}>
                                            {moment(premiumInfo.date_premium).format('DD/MM/YYYY')} · {premiumExpired ? `expiré depuis ${Math.abs(premiumDays)} j` : `${premiumDays} j`}
                                        </span>
                                    )}
                                    <button onClick={remvoeCountAskPaiement} className='df aic gap1 fr cw'><Repeat1 color='#fff' size={20} /> {countAskPaiement?.count ? (countAskPaiement?.count) : 0}</button>
                                    <button onClick={deleteAllMessage}><Trash2 color='#f71717' size={20} /></button>
                                    <button onClick={blockUser}><Ban color='#f71717' size={20} /></button>
                                    <button onClick={() => setOpenPremium(true)} title="Modifier la date premium"><CalendarClock color='#f8cc28' size={20} /></button>
                                    <div className='more-info-wrap'>
                                        <button onClick={toggleMoreInfo} style={{ padding: "0.3em 0.5em", borderRadius: "5px", fontSize: "0.8em" }} className='btn-more-info bcs cw fr'>+ d'info</button>
                                        {openMore && moreInfo && (
                                            <div className='more-info-pop'>
                                                <div className='df jcsb gap1 aic mi-row'>
                                                    <span className='mi-label'>Date création</span>
                                                    <span className='mi-value'>{moment(moreInfo?.createdAt).format('DD/MM/YYYY - HH:mm')}</span>
                                                </div>
                                                <div className='df jcsb gap1 aic mi-row'>
                                                    <span className='mi-label'>Film</span>
                                                    <span className={`mi-badge ${moreInfo?.timefilm ? "ok" : "ko"}`}>{moreInfo?.timefilm ? "OK" : "KO"}</span>
                                                </div>
                                                <div className='df jcsb gap1 aic mi-row'>
                                                    <span className='mi-label'>Série</span>
                                                    <span className={`mi-badge ${moreInfo?.timeserie ? "ok" : "ko"}`}>{moreInfo?.timeserie ? "OK" : "KO"}</span>
                                                </div>
                                                <div className='df jcsb gap1 aic mi-row'>
                                                    <span className='mi-label'>Wishlist</span>
                                                    <span className={`mi-badge ${moreInfo?.wishlist ? "ok" : "ko"}`}>{moreInfo?.wishlist ? "OK" : "KO"}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {ipInfo && (
                                <div className='fr cw df aic gap1'>
                                    <MapPin color='#fff' className='ic' />
                                    <div className='df fdc'>
                                        <p>{ipInfo.country}</p>
                                        <p>{ipInfo.region}</p>
                                        <p>{ipInfo.city}</p>

                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {notifTalk && (<button className={`${notifTalk.c} c-notif-talk df aic gap1`} onClick={() => setNotifTalk(null)}><CircleX color='#000' size={20} />{notifTalk.txt}</button>)}
            <div ref={refTalks} className='discutions oys'>
                {e.messages.map((m, i) => (
                    <div key={i + "_msg" + m.id}>
                        {m.type == "paiement_valid" && (
                            <TalkTypeValidPaiement m={m} deleteMessage={() => deleteMessage(type == "stream" ? m.id : m.idx)} />
                        )}
                        {m.type == "paiement_refuse" && (
                            <TalkTypeRefusePaiement m={m} deleteMessage={() => deleteMessage(m.id)} />
                        )}
                        {m.type == "paiement_wait" && (
                            <TalkTypeWaitAskPaiement m={m} deleteMessage={() => deleteMessage(m.id)} init={init} setNotifTalk={setNotifTalk} />
                        )}
                        {m.type == "paiement_ask_accept" && (
                            <TalkTypeWaitAskPaiementAccept m={m} deleteMessage={() => deleteMessage(m.id)} />
                        )}
                        {m.type == "paiement_ask_refuse" && (
                            <TalkTypeWaitAskPaiementRefuse m={m} deleteMessage={() => deleteMessage(m.id)} />
                        )}
                        {m.type == "paiement_ask_received" && (
                            <TalkTypeWaitAskPaiementReceived m={m} deleteMessage={() => deleteMessage(m.id)} />
                        )}
                        {m.type == "paiement_ask_received_refuse" && (
                            <TalkTypeWaitAskPaiementRefuseReceived m={m} deleteMessage={() => deleteMessage(m.id)} />
                        )}
                        {m.type == "paiement_valid_by_user" && (
                            <TalkTypeValidByUser m={m} deleteMessage={() => deleteMessage(type == "stream" ? m.id : m.idx)} init={init} setNotifTalk={setNotifTalk} type={type} />
                        )}
                        {!m.type && (
                            <div className={`${m.role == "user" ? "pl2" : "pr2"}`}>
                                <div className={`line-talk w100 df fdc ${m.role == "user" ? "" : "adm"}`} >
                                    <div className=' gap1 df jcsb '>
                                        <div className='df gap1'>
                                            <div className='c-avatar'>
                                                {m.role == "user" && type == "stream" && (
                                                    <img className='avatar' src={projectJson?.href + "/images/users/" + m.path}></img>
                                                )}
                                                {m.role == "user" && type == "sport" && (
                                                    <User className='avatar' />

                                                )}
                                                {m.role !== "user" && (
                                                    <img className='avatar admin' src={icEmpire}></img>
                                                )}
                                            </div>
                                            <div className='flex1'>
                                                {m.email && (
                                                    <p style={{ fontSize: "0.8em" }} className='fr cb'>{m.email}</p>
                                                )}
                                                {!m.email && (
                                                    <p className='fr fs1 cb'>{"Admin - " + m.role}</p>
                                                )}
                                                <div className='df aic gap1'>
                                                    <div className='df gap1 aic'>
                                                        <SendHorizonalIcon color={'#0074dc'} size={20} />
                                                        <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date).fromNow()}</p>
                                                    </div>

                                                    {m.status == "Lu" && m.date_read && (
                                                        <div className='df gap1 aic'>
                                                            <CheckCheck color={'#0074dc'} size={20} />
                                                            <p style={{ fontSize: "0.8em" }} className='fr cb tal'>{moment(m.date_read).fromNow()}</p>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                        <div className='df aic gap1'>
                                            {m.platform && mapTypePay[m.platform] && (
                                                <span className={`${mapTypePay[m.platform].cls} fr`} style={{ fontSize: "0.7em", borderRadius: "5px", padding: "0.2em 0.5em" }}>{mapTypePay[m.platform].label}</span>
                                            )}
                                            {m.platform_url && (
                                                <a href={m.platform_url} target='_blank' rel='noreferrer' className='df aic'><Link color='#0074dc' size={20} /></a>
                                            )}
                                            <button onClick={() => deleteMessage(type == "stream" ? m.id : m.idx)}><Trash2 color='#f71717' size={20} /></button>
                                        </div>
                                    </div>
                                    <p className='msg textarea cb fr mt2 w100'>{m.message}</p>
                                </div>
                            </div>
                        )}
                    </div>

                ))}
            </div>

            <form onSubmit={sendMessage} className='block-sender bcb3'>
                <img className='avatar admin' src={icEmpire}></img>
                <input className='fr px1 py1 cw flex1' placeholder='Votre Message' onFocus={(e) => { }} value={message} onChange={(e) => setMessage(e.currentTarget.value)}></input>

                <button className='btn-send'>
                    {matchSocket && !load && (
                        <SendHorizonal size={20} color='#fff' />
                    )}
                    {load && (<Loader />)}
                </button>
            </form>

            {openPremium && (
                <ModalPremiumDate idUser={e.user.id} type={type} onClose={() => setOpenPremium(false)} />
            )}
        </div>
    );
};

export default CenterTalk;